import axios from './axiosInterceptors';
import { saveAs } from 'file-saver';

const API_URL = "/api/v1/transactions/";

const searchSaleData = (formData) => {
    return axios.post(API_URL + 'search-for-external-at-sale-report', formData)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
}
const generateExcel = (data) => {
    return axios.post(API_URL + 'exportExcel', data, { responseType: 'blob' })
        .then((response) => {
            let filename = `SaleReport ${new Date().toString().substring(0, 10)}.xlsx`
            let blob = new Blob([response.data]);
            saveAs(blob, filename);
            return 'excel saved';
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err)
        })
}

const allActions = {
    searchSaleData,
    generateExcel
};

export default allActions;